@if (_selectedFilters.length > 0) {
  <div id="selected-filters" class="filters-selected-groups">
    @for (item of _selectedFilters; track item) {
      <div class="filters-selected-groups--item font-5 fw-bold">
        <span [innerHTML]="getFilterItemContent(item) | safeContent"></span
        ><button
          class="clear-selection btn btn-icon font-6 color-white"
          [attr.id]="'btn-remove-filter-' + item.attr_id + '-' + item.id"
          (click)="onRemove(item)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    }
  </div>
}
